import LessonCard from './components/LessonCard';
import $ from 'jquery';
import { dataNextPage, moreButtonSelector } from './constants';

const tutorLessonCardContainerClassname = 'tutor-lesson-card-container';
const beforeEnd = 'beforeend';
const hidden = 'hidden';

const modifyMoreButton = (isLastPage, page) => {
    $(moreButtonSelector).attr(dataNextPage, Number(page) + 1);

    if (isLastPage) {
        $(moreButtonSelector).addClass(hidden);

        return;
    }

    $(moreButtonSelector).removeClass(hidden);
}

export const render = ({data: {lessonList = null, page = 1, isLastPage = true}}) => {
    if (lessonList === null) {
        return;
    }

    const container = document.getElementsByClassName(tutorLessonCardContainerClassname)[0];

    if (page <= 1) {
        container.innerHTML = '';
    }

    lessonList.forEach(lesson => {
        container.insertAdjacentHTML(beforeEnd, LessonCard(lesson));
    });

    modifyMoreButton(isLastPage, page);
}
